import { uniqueId } from "lodash";
import { flaggReasonList } from "../../constants";

export const FlagContainer = ({
  state,
  toggleFlagContainer,
  reportFlagReason,
  flagCustomReason,
  onChangeFlag,
}) => {
  return (
    <>
      <div className="flag-icon">
        <img
          src={
            require(`@src/assets/images/vyrill/${
              state.selectedCheck && "active-"
            }flagged.png`).default
          }
          alt=""
        />
      </div>
      <p className="header" style={{ top: "0px" }}>
        I want to report this video
      </p>
      <div>
        <ul className="flaggList mb-0">
          {flaggReasonList.map((k, i) => {
            return (
              <li key={uniqueId()}>
                <label htmlFor={k}>
                  <input
                    type="radio"
                    name={k}
                    id={k}
                    value={k}
                    onChange={onChangeFlag}
                    checked={state.selectedCheck == k}
                  />
                  <div className="check"></div>
                  {k}
                </label>
              </li>
            );
          })}

          {state.isOtherOpen && (
            <textarea
              className="flag-reason-container"
              name="customNote"
              value={state.customFlagReason}
              placeholder={`Type the reason here`}
              onChange={flagCustomReason}
            />
          )}
        </ul>
        <div className="d-flex justify-content-center submit-btn">
          <div className="flag-cancel" onClick={toggleFlagContainer}>
            Cancel
          </div>
          <div className="flag-report" onClick={reportFlagReason}>
            Report
          </div>
        </div>
      </div>
    </>
  );
};
